module.exports = __webpack_public_path__ + "5620b8392dc3157e4dc26bccff1c94d2.png";